// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1nEvc","selected":"Chip_selected__GnvkP"};